import { getLegacyRedirect } from "@lib/redirects"
import { SiteShell } from "@shared/ui/SiteShell"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { ErrorPage } from "../-ErrorPage"

export const Route = createFileRoute("/$locale/$")({
  beforeLoad: ({ location }) => {
    const redirectTo = getLegacyRedirect(location.pathname)
    if (redirectTo) throw redirect({ href: redirectTo })
  },
  component: NotFound,
})

function NotFound() {
  return (
    <SiteShell page="error404">
      <ErrorPage />
    </SiteShell>
  )
}
